Attributes of the conflicting position profiles.
